<template>
  <div class="flex flex-top " style="width: 100%;margin: 10px 0">
    <div class="flex flex-top" v-if="type != data.type">
      <div class="my-avatar theme-1 mr-10 flex flex-mid flex-center">他</div>
      <div class="msg-content theme-1">
        {{data.content}}
        <br>
        <div style="text-align: right;font-size: 12px;color: #f9f9f9">{{data.createAt | SecondTimer}}</div>
      </div>
    </div>
    <div class="flex-1"></div>
    <div class="flex flex-top" v-if="type == data.type">
      <div class="msg-content theme-2">
        {{data.content}}<br>
        <div style="text-align: right;font-size: 12px;color: #f9f9f9">{{data.createAt | SecondTimer}}</div>
      </div>
      <div class="my-avatar theme-2 ml-10 flex flex-mid flex-center">我</div>
    </div>
  </div>
</template>
<script>
  export default{
      name:'message-line',
    props:['data'],
    data(){
          return{
            msg : this.data || {},
            type:this.$store.state.LoginUser.type
          }
    },
    methods:{

    },
    watch:{
      data(val){
          this.msg = val
      }
    }
  }
</script>
<style>
  .my-avatar{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    font-size: 16px;
    /*background: #d9833b;*/
    /*color: #fff;*/
  }
  .msg-content{
    min-width: 100px;
    max-width: 300px;
    padding: 10px;
    line-height: 30px;
    border-radius: 10px;


  }
  .theme-1{
    background: #d9833b;
    color: #fff;
  }
  .theme-2{
    background: #409EFF;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/MessageLine.vue